const $ = require("jquery");
window.$ = window.jQuery = $;

const utils = require("../../../utils");

class AdditionalStructures {
	constructor(reportId) {
		this.reportId = reportId;
		this.$container = $("<div class='additional-structures-container'></div>");
		this.$parentContainer = $(
			"#div" + reportId + "_index .additional-info-form .additional-structures"
		);
		this.stateModel = {
			additionalStructures: []
		};
		this.state = JSON.parse(JSON.stringify(this.stateModel));

		this.innerContainerBaseClass = "additional-structure-container";

		this.structureTypeContainerBaseClass =
			"additional-structure_type-container";
		this.structureTypeLabelBaseClass = "additional-structure_type-label";
		this.structureTypeSelectBaseClass = "additional-structure_type-select";
		this.structureTypeSelectName = "additionalStructures_structureType";

		this.squareFootageContainerBaseClass =
			"additional-structure-square_footage-container";
		this.squareFootageLabelBaseClass =
			"additional-structure-square_footage-label";
		this.squareFootageInputBaseClass =
			"additional-structure-square_footage-input";
		this.squareFootageInputName = "additionalStructures_squareFootage";

		this.yearBuiltContainerBaseClass =
			"additional-structure-year-built-container";
		this.yearBuiltLabelBaseClass = "additional-structure-year_built-label";
		this.yearBuiltInputBaseClass = "additional-structure-year_built-input";
		this.yearBuiltInputName = "additionalStructures_yearBuilt";

		this.constructionTypeContainerBaseClass =
			"additional-structure-construction_type-container";
		this.constructionTypeLabelBaseClass =
			"additional-structure-construction_type-label";
		this.constructionTypeSelectBaseClass =
			"additional-structure-construction_type-select";
		this.constructionTypeSelectName = "additionalStructures_constructionType";

		this.primaryRoofCoveringContainerBaseClass =
			"additional-structure-primary_roof_covering-container";
		this.primaryRoofCoveringLabelBaseClass =
			"additional-structure-primary_roof_covering-label";
		this.primaryRoofCoveringSelectBaseClass =
			"additional-structure-primary_roof_covering-select";
		this.primaryRoofCoveringSelectName =
			"additionalStructures_primary_roofCovering";

		this.primaryExteriorContainerBaseClass =
			"additional-structure-primary_exterior-container";
		this.primaryExteriorLabelBaseClass =
			"additional-structure-primary_exterior-label";
		this.primaryExteriorSelectBaseClass =
			"additional-structure-primary_exterior-select";
		this.primaryExteriorSelectName = "additionalStructures_primaryExterior";

		this.constructionQualityContainerBaseClass =
			"additional-structure-construction_quality-container";
		this.constructionQualityLabelBaseClass =
			"additional-structure-construction_quality-label";
		this.constructionQualitySelectBaseClass =
			"additional-structure-construction_quality-select";
		this.constructionQualitySelectName =
			"additionalStructures_constructionQuality";

		this.structureConditionContainerBaseClass =
			"additional-structure-structure_condition-container";
		this.structureConditionLabelBaseClass =
			"additional-structure-structure_condition-label";
		this.structureConditionSelectBaseClass =
			"additional-structure-structure_condition-select";
		this.structureConditionSelectName =
			"additionalStructures_structureCondition";

		this.replacementCostTypeContainerBaseClass =
			"additional-structure-replacement_cost_type-container";
		this.replacementCostTypeLabelBaseClass =
			"additional-structure-replacement_cost_type-label";
		this.replacementCostTypeSelectBaseClass =
			"additional-structure-replacement_cost_type-select";
		this.replacementCostTypeSelectName =
			"additionalStructures_replacementCostType";

		this.returnACVContainerBaseClass =
			"additional-structure-return_acv-container";
		this.returnACVLabelBaseClass = "additional-structure-return_acv-label";
		this.returnACVSelectBaseClass = "additional-structure-return_acv-select";
		this.returnACVSelectName = "additionalStructures_returnACV";

		this.returnACVGeneralConditionContainerBaseClass =
			"additional-structure-return_acv_general_condition-container";
		this.returnACVGeneralConditionLabelBaseClass =
			"additional-structure-return_acv_general_condition-label";
		this.returnACVGeneralConditionSelectBaseClass =
			"additional-structure-return_acv_general_condition-select";
		this.returnACVGeneralConditionSelectName =
			"additional-structure-returnACVGeneralCondition-container";

		this.returnACVRoofConditionContainerBaseClass =
			"additional-structure-return_acv_roof_condition-container";
		this.returnACVRoofConditionLabelBaseClass =
			"additional-structure-return_acv_roof_condition-label";
		this.returnACVRoofConditionSelectBaseClass =
			"additional-structure-return_acv_roof_condition-select";
		this.returnACVRoofConditionSelectName =
			"additional-structure-returnACVRoofCondition-container";

		this.returnACVFoundationConditionContainerBaseClass =
			"additional-structure-return_acv_foundation_condition-container";
		this.returnACVFoundationConditionLabelBaseClass =
			"additional-structure-return_acv_foundation_condition-label";
		this.returnACVFoundationConditionSelectBaseClass =
			"additional-structure-return_acv_foundation_condition-select";
		this.returnACVFoundationConditionSelectName =
			"additional-structure-returnACVFoundationCondition-container";

		this.returnACVWallConditionContainerBaseClass =
			"additional-structure-return_acv_wall_condition-container";
		this.returnACVWallConditionLabelBaseClass =
			"additional-structure-return_acv_wall_condition-label";
		this.returnACVWallConditionSelectBaseClass =
			"additional-structure-return_acv_wall_condition-select";
		this.returnACVWallConditionSelectName =
			"additional-structure-returnACVWallCondition-container";

		this.returnACVStructureInUseContainerBaseClass =
			"additional-structure-return_acv_structure_in_use-container";
		this.returnACVStructureInUseLabelBaseClass =
			"additional-structure-return_acv_structure_in_use-label";
		this.returnACVStructureInUseSelectBaseClass =
			"additional-structure-return_acv_structure_in_use-select";
		this.returnACVStructureInUseSelectName =
			"additional-structure-returnACVStructureInUse-container";

		this.addTriggerContainerBaseClass =
			"additional-structures-add-trigger-container";
		this.addTriggerLinkBaseClass = "additional-structures-add-trigger";

		this.removeTriggerBaseClass = "additional-structure-remove-trigger";
	}

	init() {
		this.createAddTrigger();
		this.$container.appendTo(this.$parentContainer);
		this.createModel();
		this.add();
		this.attachAddTriggerClickListener();
	}

	createModel() {
		let self = this;

		let $innerContainer = $(
			"<div class='" + this.innerContainerBaseClass + "'></div>"
		);

		let $removeTrigger = $(
			"<a href='#' title='Remove Structure' class='" +
				this.removeTriggerBaseClass +
				"'><i class='icon-cancel'></i></a>"
		);

		let $structureTypeContainer = $(
			"<div class='" + this.structureTypeContainerBaseClass + "'></div>"
		);
		let $structureTypeLabel = $(
			"<label class='" +
				this.structureTypeLabelBaseClass +
				"'>Structure Type:</label>"
		);
		let $structureTypeSelect = $(
			"<select class='" +
				this.structureTypeSelectBaseClass +
				"' name='" +
				this.structureTypeSelectName +
				"'></select>"
		);

		$structureTypeSelect.html(
			'<option default value="basketball court">basketball court</option><option value="barn">barn</option><option value="barn, equipment">barn, equipment</option><option value="barn, for cows">barn, for cows</option><option value="barn, for horses">barn, for horses</option><option value="barn, generic">barn, generic</option><option value="barn, hay">barn, hay</option><option value="barn, milking">barn, milking</option><option value="barn, post and beam">barn, post and beam</option><option value="boathouse">boathouse</option><option value="cabana">cabana</option><option value="caretakers house">caretakers house</option><option value="carriage house">carriage house</option><option value="club house">club house</option><option value="dock, concrete">dock, concrete</option><option value="dock, wood">dock, wood</option><option value="garage">garage</option><option value="gazebo">gazebo</option><option value="grain silo">grain silo</option><option value="greenhouse">greenhouse</option><option value="guard house">guard house</option><option value="guest house">guest house</option><option value="hot tub">hot tub</option><option value="lap pool">lap pool</option><option value="play house, childrens">play house, childrens</option><option value="pool house">pool house</option><option value="shed, equipment">shed, equipment</option><option value="shed, general purpose">shed, general purpose</option><option value="shed, run-in">shed, run-in</option><option value="shed, tractor">shed, tractor</option><option value="spring house">spring house</option><option value="storage house">storage house</option><option value="swimming pool, above ground">swimming pool, above ground</option><option value="swimming pool, inground">swimming pool, inground</option><option value="tennis court">tennis court</option>'
		);

		$(document).on(
			"change",
			"." + this.structureTypeSelectBaseClass,
			function () {
				let $el = $(this);
				let value = $el.val();

				self.repopulateSelects($el, value);
			}
		);

		let $squareFootageContainer = $(
			"<div class='" + this.squareFootageContainerBaseClass + "'></div>"
		);
		let $squareFootageLabel = $(
			"<label class='" +
				this.squareFootageLabelBaseClass +
				"'>Square Footage:</label>"
		);
		let $squareFootageInput = $(
			"<input class='" +
				this.squareFootageInputBaseClass +
				"' type='number' name='" +
				this.squareFootageInputName +
				"'>"
		);

		let $yearBuiltContainer = $(
			"<div class='" + this.yearBuiltContainerBaseClass + "'></div>"
		);
		let $yearBuiltLabel = $(
			"<label class='" +
				this.yearBuiltLabelBaseClass +
				"'>Year Built: *</label>"
		);
		let $yearBuiltInput = $(
			"<input class='" +
				this.yearBuiltInputBaseClass +
				"' type='number' name='" +
				this.yearBuiltInputName +
				"'>"
		);

		let $constructionTypeContainer = $(
			"<div class='" + this.constructionTypeContainerBaseClass + "'></div>"
		);
		let $constructionTypeLabel = $(
			"<label class='" +
				this.constructionTypeLabelBaseClass +
				"'>Construction Type:</label>"
		);
		let $constructionTypeSelect = $(
			"<select class='" +
				this.constructionTypeSelectBaseClass +
				"' name='" +
				this.constructionTypeSelectName +
				"'></select>"
		);
		$constructionTypeSelect.html("<option default value=''>N/A</option>");

		let $primaryRoofCoveringContainer = $(
			"<div class='" + this.primaryRoofCoveringContainerBaseClass + "'></div>"
		);
		let $primaryRoofCoveringLabel = $(
			"<label class='" +
				this.primaryRoofCoveringLabelBaseClass +
				"'>Primary Roof Covering:</label>"
		);
		let $primaryRoofCoveringSelect = $(
			"<select class='" +
				this.primaryRoofCoveringSelectBaseClass +
				"' name='" +
				this.primaryRoofCoveringSelectName +
				"'></select>"
		);
		$primaryRoofCoveringSelect.html("<option default value=''>N/A</option>");

		let $primaryExteriorContainer = $(
			"<div class='" + this.primaryExteriorContainerBaseClass + "'></div>"
		);
		let $primaryExteriorLabel = $(
			"<label class='" +
				this.primaryExteriorLabelBaseClass +
				"'>Primary Exterior:</label>"
		);
		let $primaryExteriorSelect = $(
			"<select class='" +
				this.primaryExteriorSelectBaseClass +
				"' name='" +
				this.primaryExteriorSelectName +
				"'></select>"
		);
		$primaryExteriorSelect.html("<option default value=''>N/A</option>");

		let $constructionQualityContainer = $(
			"<div class='" + this.constructionQualityContainerBaseClass + "'></div>"
		);
		let $constructionQualityLabel = $(
			"<label class='" +
				this.constructionQualityLabelBaseClass +
				"'>Construction Quality:</label>"
		);
		let $constructionQualitySelect = $(
			"<select class='" +
				this.constructionQualitySelectBaseClass +
				"' name='" +
				this.constructionQualitySelectName +
				"'></select>"
		);
		$constructionQualitySelect.html(
			"<option value='above average / upgraded'>above average / upgraded</option><option value='average / standard'>average / standard</option><option value='basic / economic'>basic / economic</option><option value='expensive / custom'>expensive / custom</option><option value='modest / fair'>modest / fair</option><option value='opulent / museum quality'>opulent / museum quality</option><option value='very expensive / luxury'>very expensive / luxury</option>"
		);

		let $structureConditionContainer = $(
			"<div class='" + this.structureConditionContainerBaseClass + "'></div>"
		);
		let $structureConditionLabel = $(
			"<label class='" +
				this.structureConditionLabelBaseClass +
				"'>Structure Condition:</label>"
		);
		let $structureConditionSelect = $(
			"<select class='" +
				this.structureConditionSelectBaseClass +
				"' name='" +
				this.structureConditionSelectName +
				"'></select>"
		);
		$structureConditionSelect.html(
			"<option value='excellent'>excellent</option><option value='above average'>above average</option><option value='average'>average</option><option value='below average'>below average</option><option value='poor'>poor</option>"
		);

		let $replacementCostTypeContainer = $(
			"<div class='" + this.replacementCostTypeContainerBaseClass + "'></div>"
		);
		let $replacementCostTypeLabel = $(
			"<label class='" +
				this.replacementCostTypeLabelBaseClass +
				"'>Replacement Cost Type:</label>"
		);
		let $replacementCostTypeSelect = $(
			"<select class='" +
				this.replacementCostTypeSelectBaseClass +
				"' name='" +
				this.replacementCostTypeSelectName +
				"'></select>"
		);
		$replacementCostTypeSelect.html(
			"<option value='full'>Full Replacement Cost</option><option value='func'>Functional Replacement Cost</option>"
		);

		let $returnACVContainer = $(
			"<div class='" + this.returnACVContainerBaseClass + "'></div>"
		);
		let $returnACVLabel = $(
			"<label class='" + this.returnACVLabelBaseClass + "'>Return ACV:</label>"
		);
		let $returnACVSelect = $(
			"<select class='" +
				this.returnACVSelectBaseClass +
				"' name='" +
				this.returnACVSelectName +
				"'></select>"
		);
		$returnACVSelect.html(
			"<option value='no'>no</option><option value='yes'>yes</option>"
		);

		let $returnACVGeneralConditionContainer = $(
			"<div class='" +
				this.returnACVGeneralConditionContainerBaseClass +
				"'></div>"
		);
		let $returnACVGeneralConditionLabel = $(
			"<label class='" +
				this.returnACVGeneralConditionLabelBaseClass +
				"'>General Condition:</label>"
		);
		let $returnACVGeneralConditionSelect = $(
			"<select class='" +
				this.returnACVGeneralConditionSelectBaseClass +
				"' name='" +
				this.returnACVGeneralConditionSelectName +
				"'></select>"
		);
		$returnACVGeneralConditionSelect.html(
			"<option value='excellent'>excellent</option><option value='average'>average</option><option value='fair'>fair</option><option value='poor'>poor</option><option value='dilapidated'>dilapidated</option>"
		);
		$returnACVGeneralConditionContainer.hide();

		let $returnACVRoofConditionContainer = $(
			"<div class='" +
				this.returnACVRoofConditionContainerBaseClass +
				"'></div>"
		);
		let $returnACVRoofConditionLabel = $(
			"<label class='" +
				this.returnACVRoofConditionLabelBaseClass +
				"'>Roof Condition:</label>"
		);
		let $returnACVRoofConditionSelect = $(
			"<select class='" +
				this.returnACVRoofConditionSelectBaseClass +
				"' name='" +
				this.returnACVRoofConditionSelectName +
				"'></select>"
		);
		$returnACVRoofConditionSelect.html(
			"<option value='excellent'>excellent</option><option value='average'>average</option><option value='fair'>fair</option><option value='poor'>poor</option><option value='dilapidated'>dilapidated</option>"
		);
		$returnACVRoofConditionContainer.hide();

		let $returnACVWallConditionContainer = $(
			"<div class='" +
				this.returnACVWallConditionContainerBaseClass +
				"'></div>"
		);
		let $returnACVWallConditionLabel = $(
			"<label class='" +
				this.returnACVWallConditionLabelBaseClass +
				"'>Wall Condition:</label>"
		);
		let $returnACVWallConditionSelect = $(
			"<select class='" +
				this.returnACVWallConditionSelectBaseClass +
				"' name='" +
				this.returnACVWallConditionSelectName +
				"'></select>"
		);
		$returnACVWallConditionSelect.html(
			"<option value='excellent'>excellent</option><option value='average'>average</option><option value='fair'>fair</option><option value='poor'>poor</option><option value='dilapidated'>dilapidated</option>"
		);
		$returnACVWallConditionContainer.hide();

		let $returnACVFoundationConditionContainer = $(
			"<div class='" +
				this.returnACVFoundationConditionContainerBaseClass +
				"'></div>"
		);
		let $returnACVFoundationConditionLabel = $(
			"<label class='" +
				this.returnACVFoundationConditionLabelBaseClass +
				"'>Foundation Condition:</label>"
		);
		let $returnACVFoundationConditionSelect = $(
			"<select class='" +
				this.returnACVFoundationConditionSelectBaseClass +
				"' name='" +
				this.returnACVFoundationConditionSelectName +
				"'></select>"
		);
		$returnACVFoundationConditionSelect.html(
			"<option value='excellent'>excellent</option><option value='average'>average</option><option value='fair'>fair</option><option value='poor'>poor</option><option value='dilapidated'>dilapidated</option>"
		);
		$returnACVFoundationConditionContainer.hide();

		let $returnACVStructureInUseContainer = $(
			"<div class='" +
				this.returnACVStructureInUseContainerBaseClass +
				"'></div>"
		);
		let $returnACVStructureInUseLabel = $(
			"<label class='" +
				this.returnACVStructureInUseLabelBaseClass +
				"'>Structure In Use:</label>"
		);
		let $returnACVStructureInUseSelect = $(
			"<select class='" +
				this.returnACVStructureInUseSelectBaseClass +
				"' name='" +
				this.returnACVStructureInUseSelectName +
				"'></select>"
		);
		$returnACVStructureInUseSelect.html(
			"<option value='yes'>yes</option><option value='no'>no</option>"
		);
		$returnACVStructureInUseContainer.hide();

		$(document).on("change", "." + this.returnACVSelectBaseClass, function (e) {
			if ($(this).val() === "yes") {
				$(this)
					.parents("." + self.innerContainerBaseClass)
					.find("." + self.returnACVGeneralConditionContainerBaseClass)
					.show();
				$(this)
					.parents("." + self.innerContainerBaseClass)
					.find("." + self.returnACVRoofConditionContainerBaseClass)
					.show();
				$(this)
					.parents("." + self.innerContainerBaseClass)
					.find("." + self.returnACVWallConditionContainerBaseClass)
					.show();
				$(this)
					.parents("." + self.innerContainerBaseClass)
					.find("." + self.returnACVFoundationConditionContainerBaseClass)
					.show();
				$(this)
					.parents("." + self.innerContainerBaseClass)
					.find("." + self.returnACVStructureInUseContainerBaseClass)
					.show();
			} else {
				$(this)
					.parents("." + self.innerContainerBaseClass)
					.find("." + self.returnACVGeneralConditionContainerBaseClass)
					.hide();
				$(this)
					.parents("." + self.innerContainerBaseClass)
					.find("." + self.returnACVRoofConditionContainerBaseClass)
					.hide();
				$(this)
					.parents("." + self.innerContainerBaseClass)
					.find("." + self.returnACVWallConditionContainerBaseClass)
					.hide();
				$(this)
					.parents("." + self.innerContainerBaseClass)
					.find("." + self.returnACVFoundationConditionContainerBaseClass)
					.hide();
				$(this)
					.parents("." + self.innerContainerBaseClass)
					.find("." + self.returnACVStructureInUseContainerBaseClass)
					.hide();
			}
		});

		$removeTrigger.appendTo($innerContainer);

		$structureTypeLabel.appendTo($structureTypeContainer);
		$structureTypeSelect.appendTo($structureTypeContainer);

		$squareFootageLabel.appendTo($squareFootageContainer);
		$squareFootageInput.appendTo($squareFootageContainer);

		$yearBuiltLabel.appendTo($yearBuiltContainer);
		$yearBuiltInput.appendTo($yearBuiltContainer);

		$constructionTypeLabel.appendTo($constructionTypeContainer);
		$constructionTypeSelect.appendTo($constructionTypeContainer);

		$primaryRoofCoveringLabel.appendTo($primaryRoofCoveringContainer);
		$primaryRoofCoveringSelect.appendTo($primaryRoofCoveringContainer);

		$primaryExteriorLabel.appendTo($primaryExteriorContainer);
		$primaryExteriorSelect.appendTo($primaryExteriorContainer);

		$constructionQualityLabel.appendTo($constructionQualityContainer);
		$constructionQualitySelect.appendTo($constructionQualityContainer);

		$structureConditionLabel.appendTo($structureConditionContainer);
		$structureConditionSelect.appendTo($structureConditionContainer);

		$replacementCostTypeLabel.appendTo($replacementCostTypeContainer);
		$replacementCostTypeSelect.appendTo($replacementCostTypeContainer);

		$returnACVLabel.appendTo($returnACVContainer);
		$returnACVSelect.appendTo($returnACVContainer);

		$returnACVGeneralConditionLabel.appendTo(
			$returnACVGeneralConditionContainer
		);
		$returnACVGeneralConditionSelect.appendTo(
			$returnACVGeneralConditionContainer
		);

		$returnACVRoofConditionLabel.appendTo($returnACVRoofConditionContainer);
		$returnACVRoofConditionSelect.appendTo($returnACVRoofConditionContainer);

		$returnACVWallConditionLabel.appendTo($returnACVWallConditionContainer);
		$returnACVWallConditionSelect.appendTo($returnACVWallConditionContainer);

		$returnACVFoundationConditionLabel.appendTo(
			$returnACVFoundationConditionContainer
		);
		$returnACVFoundationConditionSelect.appendTo(
			$returnACVFoundationConditionContainer
		);

		$returnACVStructureInUseLabel.appendTo($returnACVStructureInUseContainer);
		$returnACVStructureInUseSelect.appendTo($returnACVStructureInUseContainer);

		$structureTypeContainer.appendTo($innerContainer);
		$squareFootageContainer.appendTo($innerContainer);
		$yearBuiltContainer.appendTo($innerContainer);
		$constructionTypeContainer.appendTo($innerContainer);
		$primaryRoofCoveringContainer.appendTo($innerContainer);
		$primaryExteriorContainer.appendTo($innerContainer);
		$constructionQualityContainer.appendTo($innerContainer);
		$structureConditionContainer.appendTo($innerContainer);
		$replacementCostTypeContainer.appendTo($innerContainer);
		$returnACVContainer.appendTo($innerContainer);
		$returnACVGeneralConditionContainer.appendTo($innerContainer);
		$returnACVRoofConditionContainer.appendTo($innerContainer);
		$returnACVWallConditionContainer.appendTo($innerContainer);
		$returnACVFoundationConditionContainer.appendTo($innerContainer);
		$returnACVStructureInUseContainer.appendTo($innerContainer);

		this.$elModel = $innerContainer;
	}

	repopulateSelects($el, val) {
		let $parentContainer = $el.parents("." + this.innerContainerBaseClass);

		switch (val) {
			case "basketball court":
				$parentContainer
					.find("." + this.squareFootageInputBaseClass)
					.attr("disabled", true)
					.val(null);
				$parentContainer
					.find("." + this.constructionTypeSelectBaseClass)
					.html(
						"<option value='hard court'>hard court</option><option value='Har-Tru'>Har-Tru</option><option value='wood'>wood</option><option value='wood, parquet'>wood, parquet</option>"
					);
				$parentContainer
					.find("." + this.primaryRoofCoveringSelectBaseClass)
					.html("<option value=''>N/A</option>");
				$parentContainer
					.find("." + this.primaryExteriorSelectBaseClass)
					.html("<option value=''>N/A</option>");
				break;
			case "dock, concrete":
			case "dock, wood":
				$parentContainer
					.find("." + this.squareFootageInputBaseClass)
					.attr("disabled", false);
				$parentContainer
					.find("." + this.constructionTypeSelectBaseClass)
					.html(
						"<option value='frame, wood'>frame, wood</option><option value='masonry, stone'>masonry, stone</option>"
					);
				$parentContainer
					.find("." + this.primaryRoofCoveringSelectBaseClass)
					.html("<option value=''>N/A</option>");
				$parentContainer
					.find("." + this.primaryExteriorSelectBaseClass)
					.html("<option value=''>N/A</option>");
				break;
			case "hot tub":
				$parentContainer
					.find("." + this.squareFootageInputBaseClass)
					.attr("disabled", true)
					.val(null);
				$parentContainer
					.find("." + this.constructionTypeSelectBaseClass)
					.html(
						"<option value='large, 4+ people'>large, 4+ people</option><option value='medium, 3 - 4 person'>medium, 3 - 4 person</option><option value='small, 2 person'>small, 2 person</option>"
					);
				$parentContainer
					.find("." + this.primaryRoofCoveringSelectBaseClass)
					.html("<option value=''>N/A</option>");
				$parentContainer
					.find("." + this.primaryExteriorSelectBaseClass)
					.html("<option value=''>N/A</option>");
				break;
			case "lap pool":
			case "swimming pool, above ground":
			case "swimming pool, inground":
				$parentContainer
					.find("." + this.squareFootageInputBaseClass)
					.attr("disabled", true)
					.val(null);
				$parentContainer
					.find("." + this.constructionTypeSelectBaseClass)
					.html(
						"<option value='concrete'>concrete</option><option value='Gunite, black'>Gunite, black</option><option value='Gunite, regular'>Gunite, regular</option><option value='tiled'>tiled</option><option value='vinyl lined'>vinyl lined</option>"
					);
				$parentContainer
					.find("." + this.primaryRoofCoveringSelectBaseClass)
					.html("<option value=''>N/A</option>");
				$parentContainer
					.find("." + this.primaryExteriorSelectBaseClass)
					.html("<option value=''>N/A</option>");
				break;
			case "tennis court":
				$parentContainer
					.find("." + this.squareFootageInputBaseClass)
					.attr("disabled", true)
					.val(null);
				$parentContainer
					.find("." + this.constructionTypeSelectBaseClass)
					.html(
						"<option value='clay'>clay</option><option value='grass'>grass</option><option value='hard court'>hard court</option><option value='Har-Tru'>Har-Tru</option>"
					);
				$parentContainer
					.find("." + this.primaryRoofCoveringSelectBaseClass)
					.html("<option value=''>N/A</option>");
				$parentContainer
					.find("." + this.primaryExteriorSelectBaseClass)
					.html("<option value=''>N/A</option>");
				break;
			default:
				$parentContainer
					.find("." + this.squareFootageInputBaseClass)
					.attr("disabled", false);
				$parentContainer
					.find("." + this.constructionTypeSelectBaseClass)
					.html(
						"<option value='A - frame'>A - frame</option><option value='autoclaved aerated concrete'>autoclaved aerated concrete</option><option value='foam form concrete'>foam form concrete</option><option value='framing, steel'>framing, steel</option><option value='framing, wood'>framing, wood</option><option value='framing, wood with elevated slab'>framing, wood with elevated slab</option><option value='log'>log</option><option value='masonry, block'>masonry, block</option><option value='masonry, brick'>masonry, brick</option><option value='masonry, stone'>masonry, stone</option><option value='modular, wood frame'>modular, wood frame</option><option value='pole frame'>pole frame</option><option value='poured concrete'>poured concrete</option><option value='rammed earth'>rammed earth</option><option value='rigid metal frame'>rigid metal frame</option><option value='soil cement'>soil cement</option><option value='stick'>stick</option><option value='strawbale'>strawbale</option><option value='structural insulated panel'>structural insulated panel</option><option value='stucco on frame'>stucco on frame</option><option value='stucco on masonry'>stucco on masonry</option><option value='timber/post &amp; beam'>timber/post &amp; beam</option><option value='veneer, brick'>veneer, brick</option><option value='veneer, brick with wood frame'>veneer, brick with wood frame</option><option value='veneer, stone'>veneer, stone</option>"
					);
				$parentContainer
					.find("." + this.primaryRoofCoveringSelectBaseClass)
					.html(
						"<option value='aluminum'>aluminum</option><option value='architectural shingle'>architectural shingle</option><option value='asbestos shingle replacement'>asbestos shingle replacement</option><option value='asphalt shingle'>asphalt shingle</option><option value='asphalt shingle with solar panels'>asphalt shingle with solar panels</option><option value='barrel tile'>barrel tile</option><option value='cedar shingle/shake'>cedar shingle/shake</option><option value='cement fiber'>cement fiber</option><option value='clay tile'>clay tile</option><option value='composition roll'>composition roll</option><option value='composition shingle'>composition shingle</option><option value='composition, built-up'>composition, built-up</option><option value='concrete tile'>concrete tile</option><option value='Dibiten'>Dibiten</option><option value='dimensional asphalt shingle'>dimensional asphalt shingle</option><option value='earth covered'>earth covered</option><option value='Elastomeric'>Elastomeric</option><option value='EPDM membrane'>EPDM membrane</option><option value='fiberglass shingle'>fiberglass shingle</option><option value='glass panel'>glass panel</option><option value='glazed tile'>glazed tile</option><option value='hail proof shingle'>hail proof shingle</option><option value='Lamarite shingle'>Lamarite shingle</option><option value='Ludowici tile'>Ludowici tile</option><option value='metal other than standing seam'>metal other than standing seam</option><option value='metal, corrugated'>metal, corrugated</option><option value='metal, ribbed'>metal, ribbed</option><option value='Minera shingle'>Minera shingle</option><option value='polyurethane foam'>polyurethane foam</option><option value='PVC membrane'>PVC membrane</option><option value='red slate'>red slate</option><option value='rubber'>rubber</option><option value='slate'>slate</option><option value='slate, graduated'>slate, graduated</option><option value='slate, patterned'>slate, patterned</option><option value='slate, synthetic'>slate, synthetic</option><option value='solar shingles'>solar shingles</option><option value='Spanish tile'>Spanish tile</option><option value='standing seam copper'>standing seam copper</option><option value='standing seam metal'>standing seam metal</option><option value='steel'>steel</option><option value='steel with solar panels'>steel with solar panels</option><option value='tar and gravel'>tar and gravel</option><option value='tile with solar panels'>tile with solar panels</option><option value='TPO membrane'>TPO membrane</option><option value='wood shake'>wood shake</option><option value='wood shingle'>wood shingle</option>"
					);

				$parentContainer
					.find("." + this.primaryExteriorSelectBaseClass)
					.html(
						"<option value='adobe'>adobe</option><option value='aluminum siding'>aluminum siding</option><option value='asbestos replacement, cement fiber'>asbestos replacement, cement fiber</option><option value='asphalt'>asphalt</option><option value='autoclaved aerated concrete, exposed'>autoclaved aerated concrete, exposed</option><option value='autoclaved aerated concrete, painted'>autoclaved aerated concrete, painted</option><option value='board and batten'>board and batten</option><option value='brick masonry'>brick masonry</option><option value='brick w/block backup'>brick w/block backup</option><option value='brownstone'>brownstone</option><option value='cedar siding'>cedar siding</option><option value='cement fiber'>cement fiber</option><option value='clapboard'>clapboard</option><option value='clay tile'>clay tile</option><option value='concrete block'>concrete block</option><option value='concrete block, painted'>concrete block, painted</option><option value='concrete, reinforced'>concrete, reinforced</option><option value='decorative wood shingle'>decorative wood shingle</option><option value='Drivit/EIFS'>Drivit/EIFS</option><option value='engineered wood siding'>engineered wood siding</option><option value='glass block'>glass block</option><option value='glass panels'>glass panels</option><option value='half log siding'>half log siding</option><option value='hardboard'>hardboard</option><option value='limestone'>limestone</option><option value='local stone'>local stone</option><option value='log (&lt;11&quot;diameter>'>log (&lt;11&quot;diameter></option><option value='log (&gt;11&quot;diameter>'>log (&gt;11&quot;diameter></option><option value='Masonite'>Masonite</option><option value='metal siding'>metal siding</option><option value='paint'>paint</option><option value='plywood with batts'>plywood with batts</option><option value='precast concrete'>precast concrete</option><option value='precast stone'>precast stone</option><option value='rammed earth'>rammed earth</option><option value='redwood siding'>redwood siding</option><option value='siding, log'>siding, log</option><option value='solid stone'>solid stone</option><option value='steel siding'>steel siding</option><option value='stone rubble'>stone rubble</option><option value='stucco'>stucco</option><option value='stucco over masonry'>stucco over masonry</option><option value='stucco with half timbering'>stucco with half timbering</option><option value='stucco, slick finish'>stucco, slick finish</option><option value='stucco, smooth coat'>stucco, smooth coat</option><option value='stucco, Tuscan finish'>stucco, Tuscan finish</option><option value='T1-11 siding'>T1-11 siding</option><option value='Tabby siding'>Tabby siding</option><option value='veneer, common brick'>veneer, common brick</option><option value='veneer, face brick'>veneer, face brick</option><option value='veneer, rubble'>veneer, rubble</option><option value='veneer, stone'>veneer, stone</option><option value='veneer, synthetic brick'>veneer, synthetic brick</option><option value='veneer, synthetic stone'>veneer, synthetic stone</option><option value='vinyl siding'>vinyl siding</option><option value='wood shake/shingle'>wood shake/shingle</option><option value='wood siding'>wood siding</option><option value='wood stresskin panels'>wood stresskin panels</option>"
					);
				break;
		}
	}

	createAddTrigger() {
		this.$addTriggerContainer = $(
			"<div class='" + this.addTriggerContainerBaseClass + "'></div>"
		);

		this.$addTrigger = $(
			"<a href='#' class='" +
				this.addTriggerLinkBaseClass +
				"'><i class='icon-plus'></i>Add Additional Structure</a>"
		);
		this.$addTrigger.appendTo(this.$addTriggerContainer);
		this.$addTriggerContainer.appendTo(this.$parentContainer);
	}

	attachAddTriggerClickListener() {
		let self = this;

		this.$addTrigger.on("click", function (e) {
			e.preventDefault();
			self.add();
		});
	}

	add() {
		var $el = this.$elModel.clone().insertBefore(this.$addTriggerContainer);
		this.attachRemoveTriggerClickListener($el);

		$("." + this.innerContainerBaseClass).each(function (index) {
			$(this)
				.find("select, input, textarea")
				.each(function () {
					$(this).attr("id", $(this).attr("name") + "_" + index);
				});
		});

		$el.find("." + this.structureTypeSelectBaseClass).trigger("change");

		return $el;
	}

	populateValues($el, inputs) {
		for (var input in inputs) {
			$el
				.find('*[name="additionalStructures_' + input + '"]')
				.val(inputs[input]);

			if (input === "structureType" || input === "returnACV") {
				$el
					.find('*[name="additionalStructures_' + input + '"]')
					.trigger("change");
			}
		}
	}

	attachRemoveTriggerClickListener($el) {
		let self = this;

		$el.find("." + this.removeTriggerBaseClass).on("click", function (e) {
			e.preventDefault();
			self.remove($el);
		});
	}

	remove($el) {
		$el.remove();
	}

	removeAll() {
		let self = this;

		$("." + this.innerContainerBaseClass).each(function () {
			self.remove($(this));
		});
	}
}

module.exports = AdditionalStructures;
